import { ReactNode } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { SearchField } from '@factorialco/deprecated-design-system'

import AddFilter, { FilterOptions } from 'modules/core/components/Filter/filters/AddFilter'

interface FilterManagerProps {
  persistentFilters: ReactNode[]
  conditionalFilters: ReactNode[]
  availableFilters: FilterOptions
  onSelectFilter: (filterKey: string) => void
  searchConfig?: {
    search: string
    onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
    placeholder: string
    collapsable?: boolean
  }
}

export const FilterManager = ({
  persistentFilters,
  conditionalFilters,
  availableFilters,
  onSelectFilter,
  searchConfig,
}: FilterManagerProps) => {
  return (
    <Box flexDirection="row" gap="s24" alignItems="center" width="full">
      <Box flexDirection="row" gap="s8" alignItems="flexStart" overflowX="auto" width="full">
        {persistentFilters}

        {conditionalFilters}

        <AddFilter availableFilters={availableFilters} onSelectFilter={onSelectFilter} />
      </Box>

      {searchConfig && (
        <Box maxWidth="s200">
          <SearchField
            collapsable={searchConfig.collapsable}
            search={searchConfig.search}
            onSearch={searchConfig.onSearch}
            placeholder={searchConfig.placeholder}
          />
        </Box>
      )}
    </Box>
  )
}
